import { Redirect } from "expo-router";

import { CentralRouteGuard } from "../src/components/CentralRouteGuard";
import AdminOperationsScreen from "../src/features/arrangements/screens/AdminOperationsScreen";
import LandingPage from "../src/features/landing/LandingPage";
import { useAppStore } from "../src/providers/AppProvider";
import { LoadingState } from "../src/components/ui";
import { isCentralHost } from "../src/lib/hosting";

export default function IndexScreen() {
  const centralHost = isCentralHost();
  const { ready, staffSessionActive } = useAppStore();

  if (!centralHost) {
    return <LandingPage />;
  }

  if (!ready) {
    return <LoadingState label="Preparing WeHonor" description="Restoring your workspace." />;
  }

  return staffSessionActive ? (
    <CentralRouteGuard>
      <AdminOperationsScreen />
    </CentralRouteGuard>
  ) : (
    <Redirect href="/signed-out" />
  );
}
